import ICONS from "../../../assets/Icons";
import ReimbursementTransactionsViewAll from "../../../containers/Transactions/ReimbursementTransactions/ReimbursementTransactionViewAll";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import TEXT from "../../../utils/globalText";
import useCategories from "../../../utils/useCategories";
import CommonLayout from "../../_utils/CommonLayout";
import LargePopupRedirect from "../../_utils/CommonPopups/CommonLargePopupRedirect";
import FileFormatMapper from "../../_utils/FileFormatMapper";
import TickerAnimation from "../../_utils/TickerAnimation";
import TitleSubtitlePair from "../../_utils/TitleSubtitlePair";
import AdditionalDetailsPreviewMapper from "../../_utils/TransactionCommonComponents/AdditionalDetailsPreviewMapper";
import Amount from "../../_utils/TransactionCommonComponents/Amount";
import CategorySelector from "../../_utils/TransactionCommonComponents/CategorySelector";
import PaymentMethodSelector from "../../_utils/TransactionCommonComponents/PaymentMethodSelector";
import SourceDestinationAccountDetail from "../../_utils/TransactionCommonComponents/SourceDestinationAccountDetail";
import DestinationReimbursement from "../DestinationReimbursement";

const TxnConfirm = (props) => {
  const categoryMapper = useCategories();
  const allLabels = [
    ...new Set([
      ...(props?.txnPayLoad?.labels || []),
      ...(props?.txnPayLoad?.ownerLabels || []),
    ]),
  ];
  const formatDate = (date) => {
    return `${date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()} ${date.toLocaleString(
      "default",
      {
        month: "short",
      },
    )}, ${date.getFullYear()}`;
  };

  const normalizedCategories = Array.isArray(props?.txnPayLoad?.mergeCategory)
    ? props.txnPayLoad.mergeCategory
        .map((cat) => {
          if (typeof cat === "string") return cat;
          if (typeof cat === "object" && cat !== null)
            return cat?.name || cat?.category || "";
          return "";
        })
        .map((cat) => cat.trim())
        .filter(Boolean)
    : [];

  return (
    <>
      {props?.showSimilarModal && (
        <div className="fixed z-z-index-modal top-left-base left-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <LargePopupRedirect
            headerTitle={"Similar transactions found"}
            headersubtext={
              "Transactions with similar details have already been created. Proceeding will result in a duplicate transaction."
            }
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={() => props?.setShowSimilarModal(false)}
            closeicon={ICONS?.CLOSE}
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            enabledBgColor={"var(--negative-act)"}
            hoverOption={"dark"}
            outLineColor={""}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            isDisabled={false}
            confirmbtnrequired={true}
            isbottomSectionneed={true}
            bottomHeaderTextNeed={true}
            btnText="Proceed with caution"
            handleFunction={() => {
              props?.setShowSimilarModal(false);
              props?.onForceCreate();
            }}
            bottomHeaderText={"Proceed with creating this transaction?"}
          >
            <ReimbursementTransactionsViewAll
              bene_account_name={props?.txnPayLoad?.bankAccountName || "NA"}
              bene_account_id={props?.txnPayLoad?.beneAccountId || null}
              bene_account_confidential={
                props?.txnPayLoad?.beneAccountId || null
              }
              onClose={() => {
                props?.setShowSimilarModal(false);
              }}
              queryParams={props?.queryParams}
              similarTxnType={"similarTxn"}
            />
          </LargePopupRedirect>
        </div>
      )}
      <div
        className={`w-width-full Qlg:px-padding-base px-padding-md   max-w-tab-width-normal mx-auto`}
      >
        <CommonLayout>
          <div className="w-width-full lg:max-w-[var(--create-box-width)]">
            <SourceDestinationAccountDetail
              type="source"
              txnPayLoad={props.txnPayLoad}
              setTxnPayLoad={props.setTxnPayLoad}
              page="confirm"
            />
          </div>

          <div className="w-width-full lg:max-w-[var(--create-box-width)]">
            <DestinationReimbursement
              txnPayLoad={props.txnPayLoad}
              setTxnPayLoad={props.setTxnPayLoad}
              page="confirm"
            />
          </div>

          <div className="flex flex-col gap-gap-md">
            <Amount
              isPreview={true}
              txnPayLoad={props?.txnPayLoad}
            />
            <PaymentMethodSelector
              previewMode={true}
              showUnassignLink={false}
              selectedMethod={props?.txnPayLoad?.settleType}
            />
          </div>

          <div className="w-width-full h-auto p-padding-md rounded-border-radius-md bg-primary-card">
            <p className="text-left text-base mb-margin-md text-text-primary">
              <span className="font-semibold">Reimbursement Details</span>
            </p>
            <TitleSubtitlePair
              title={props.txnPayLoad.expenseType}
              subtitle="Expense type"
            />
            <div class="border-border border-primary-bg my-margin-sm"></div>
            <TitleSubtitlePair
              title={formatDate(new Date(props?.txnPayLoad?.date))}
              subtitle="Reimbursement date"
            />
            <div class="border-border border-primary-bg my-margin-sm"></div>
            <div className="flex justify-between">
              <TitleSubtitlePair
                title={
                  props?.flow === "PayReimburseTxn"
                    ? props?.txnPayLoad?.uploadFile?.metadata?.filename
                    : props.txnPayLoad.uploadFile.name
                }
                subtitle="Upload file"
              />{" "}
              <div className="flex items-center justify-end">
                {" "}
                <img
                  src={(() => {
                    const extension =
                      props?.flow === "PayReimburseTxn"
                        ? (
                            props?.txnPayLoad?.uploadFile?.metadata?.filename ||
                            props?.txnPayLoad?.uploadFile?.name
                          )
                            ?.split(".")
                            ?.pop()
                            ?.toLowerCase()
                        : props?.txnPayLoad?.uploadFile?.name
                            ?.split(".")
                            ?.pop()
                            ?.toLowerCase();

                    return FileFormatMapper(extension, "confirm");
                  })()}
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src =
                      "https://q2pay.in/new_assets/common/file_format/default.svg";
                  }}
                  alt="file"
                  className="w-icon-lg h-icon-lg shrink-0"
                />
              </div>
            </div>
            <div class="border-border border-primary-bg my-margin-sm"></div>
            <div className="flex justify-between items-start gap-gap-sm w-width-full">
              <TitleSubtitlePair
                title={props.txnPayLoad.description || "N/A"}
                subtitle="Description (optional)"
              />
            </div>
          </div>

          <div className="flex flex-col gap-gap-md">
            <div className="w-width-full h-auto p-padding-md rounded-border-radius-md bg-primary-card">
              <p className="text-left text-base mb-margin-md text-text-primary">
                <span className="font-semibold">Maker's Commment</span>
                <span className="font-normal"> (Optional)</span>
              </p>

              <p className="text-text-primary text-font-md break-words ">
                {props.txnPayLoad.comment || "N/A"}
              </p>

              <p className="text-text-secondary text-font-xs font-normal mt-margin-xs">
                {"Comment"}
              </p>
            </div>

            {props?.flow === "PayReimburseTxn" ? (
              <>
                <div className=" w-full bg-primary-card p-padding-md rounded-border-radius-md">
                  <div>
                    <p className=" text-font-md text-text-primary font-semibold">
                      Transaction Category
                    </p>
                  </div>
                  <div
                    className={`rounded-border-radius-md  flex mt-margin-md items-center relative z-z-index-base w-width-full`}
                    style={{ background: "var(--category-background)" }}
                  >
                    <div className=" p-padding-sm flex items-center justify-center rounded-l-border-radius-md">
                      <img
                        className="w-icon-lg h-icon-lg flex-shrink-0"
                        src={categoryMapper(props.txnPayLoad.categories)}
                        alt="category"
                      />
                    </div>

                    <div
                      className={`flex relative z-z-index-base 
                    bg-primary-nav
                   rounded-r-border-radius-md flex-1 items-center overflow-hidden`}
                    >
                      <div className="Qmd:w-width_xl w-width-md relative z-z-index-base flex flex-col gap-gap-xs items-center justify-between flex-1 pr-padding-md pl-padding-sm py-padding-sm transition-colors duration-animation-fast-s">
                        <p className="w-width-full text-text-primary font-semibold text-sm break-all mb-request-padding pt-padding-sm pr-padding-xs">
                          <TickerAnimation text={props.txnPayLoad.categories} />
                        </p>

                        <p
                          className="w-width-full text-text-primary text-xs pr-padding-xs break-all"
                          style={{
                            visibility: "hidden",
                          }}
                        >
                          <TickerAnimation text={props.txnPayLoad.categories} />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="lg:max-w-[var(--create-box-width)]  w-width-full">
                  <CategorySelector
                    previewMode={true}
                    selectedCategory={props?.txnPayLoad?.selectedCategory}
                    category={normalizedCategories}
                    IFSC={props?.txnPayLoad?.bankAccountIFSC}
                    accountNumber={props?.txnPayLoad?.bankAccountNo}
                    beneAccountId={props?.txnPayLoad?.beneAccountId}
                    unassignCategories={[]}
                    unassignlength={[]}
                  />
                </div>
              </>
            )}
          </div>

          <div className="w-width-full lg:max-w-[var(--create-box-width)]">
            <div className="w-width-full h-auto p-padding-md rounded-border-radius-md bg-primary-card">
              <p className="text-left text-base mb-margin-md text-text-primary">
                <span className="font-semibold">Labels</span>
                <span className="font-normal"> (Optional)</span>
              </p>

              <p className="text-text-primary text-font-sm break-words lg:break-normal lg:whitespace-normal">
                {allLabels.length === GlobalConfiguration.lengthCheckZero ? (
                  <span>{TEXT?.NO_LABELS_ASSIGNED}</span>
                ) : (
                  allLabels.map((item, index) => (
                    <span key={index}>
                      {item}
                      {index <
                        allLabels.length - GlobalConfiguration.lengthCheckOne &&
                        ", "}
                    </span>
                  ))
                )}
              </p>

              <p className="text-text-secondary text-font-xs font-normal mt-margin-xs">
                {TEXT?.LABELS}
              </p>
            </div>
          </div>

          <div className="lg:max-w-[var(--create-box-width)] w-width-full mb-margin-md">
            <AdditionalDetailsPreviewMapper
              mappingData={props.txnPayLoad.mergeCategory}
              previewImages={props?.previewImages}
            />
          </div>
        </CommonLayout>

        <div className="h-mobile-create-header w-width-full Qmd:hidden block"></div>
      </div>
    </>
  );
};

export default TxnConfirm;
